<app-loader></app-loader>

<div class="payment-option">
    <p>Choose payment option</p>
    <div class="custom-close" (click)="close()">
        <img src="../../assets/images/new-close.svg" alt="Close" />
    </div>
</div>
    <div *ngIf="bookingScheduledDate" class="schedule-message">
         {{bookingScheduledDate}}
    </div>

<div class="booking-summary driver-booking-summer">
            
    <div class="payment-fullwidth">
        <div class="payment-outer">
            <div class="common-border">
                <div class="perferd-outer">
                    <div class="premed-checkbox" *ngIf="displayedPaymentMethods?.length">
                        <p-checkbox [binary]="true" inputId="binary" [(ngModel)]="isPreferredPaymentSelected"
                            (onChange)="onPreferredCheck(isPreferredPaymentSelected)" />
                        <h5>Preferred Payment Method</h5>
                    </div>
                    <div class="method-outer">
                        <h4>Select Payment Method <span class="custom-star">*</span></h4>
                    </div>
                    <div [class.pay-border]="displayedPaymentMethods?.length" [class.view-scroll]="viewMore">                      
                        <div *ngFor="let data of displayedPaymentMethods" class="payment-method-box"
                            [class.disabled]="!isPreferredPaymentSelected">

<div *ngIf="data.type === 'card'; else bankDetails">
        
                                <div class="card-information">
                                    <ul>
                                        <li class="li-first">
                                            <div class="holder-name account-no">
                                                <p-radioButton [class.disabled]="!isPreferredPaymentSelected" name="paymentMethod" [(ngModel)]="paymentMethodSelected"
                                                    [value]="data" (click)="onPaymentChange(data)"
                                                    inputId="paymentRadio{{data.last4}}" />
                                                <div class="card-no">
                                                    <h4>Card Number</h4>
                                                    <p>XXXXXXXXXXXX{{data.last4}}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="li-second">
                                            <div class="holder-name">
                                                <h4>Expiry Date</h4>
                                                <p>{{data.expMonth}}/{{data.expYear}}</p>
                                            </div>
                                        </li>
                                        <li class="li-third">
                                            <div class="holder-name">
                                                <h4>Card Holder Name</h4>
                                                <p>{{data.cardHolderName}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                            </div>

<ng-template #bankDetails>
                                <div class="card-information">
                                    <ul>
                                        <li class="li-first">
                                            <div class="holder-name account-no">
                                                <p-radioButton [class.disabled]="!isPreferredPaymentSelected" name="paymentMethod" [(ngModel)]="paymentMethodSelected"
                                                    [value]="data" (click)="onPaymentChange(data)"
                                                    inputId="paymentRadio{{data.last4}}" />
                                                <div class="card-no">
                                                    <h4>Account Number</h4>
                                                    <p>XXXXXXXXXXXX{{data.last4}}</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="li-second">
                                            <div class="holder-name">
                                                <h4>Bank Name</h4>
                                                <p>{{data.bankName}}</p>
                                            </div>
                                        </li>
                                        <li class="li-third">
                                            <div class="holder-name">
                                                <h4>Account Holder Name</h4>
                                                <p>{{data.accountHolderName}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </ng-template>
                        </div>

                        <div class="view-more" *ngIf="paymentMethodDetails?.length > 2">
                            <p (click)="viewMoreToggal()" *ngIf="!viewMore">View More</p>   
                        </div>
                    </div>
                </div>

                <form *ngIf="!isPreferredPaymentSelected">
                    <div class="payment-main">
                        <div class="Payment-inner">
                            <div class="card-outer" (click)="getSelectedPaymentMethod(1)">
                                <div class="card-inner">
                                    <h4>
                                        <img src="../../../../../assets/images/payment-card.svg" alt="" />
                                        <span>Card</span>
                                    </h4>
                                    <div class="radio-outer">
                                        <p-radioButton class="payment-method" name="paymentMethod" [value]="1"
                                        [(ngModel)]="selectedPaymentMethod"     variant="filled" />
                                    </div>
                                </div>
                            </div>
                            <div class="card-outer" *ngIf="bookingDetails?.bookingType !=0" (click)="getSelectedPaymentMethod(2)">
                                <div class="card-inner">
                                    <h4>
                                        <img src="../../../../../assets/images/ech-icon.svg" alt="" />
                                        <span>ACH/US Bank Account</span>
                                    </h4>
                                    <div class="radio-outer">
                                        <p-radioButton class="payment-method" name="paymentMethod" [value]="2"
                                        [(ngModel)]="selectedPaymentMethod"  variant="filled" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div *ngIf="isPaymentMethodValid" class="pass-err">
                    Payment method is required.
                </div>
                <div class="parking-durationbox" *ngIf="!updateBookindDetailsValue && bookingType">
                    <div *ngIf="bookingDetails?.duration" class="duration-inner">
                        <h4>Parking Duration</h4>
                        <h4>{{bookingDetails?.duration}}</h4>
                    </div>
                    <div *ngIf="bookingDetails?.amount" class="duration-inner">
                        <h4>Amount</h4>
                        <h4>${{bookingDetails?.amount}}</h4>
                    </div>
                    <div *ngIf="bookingDetails?.coupanAmount>0" class="duration-inner">
                        <h4 *ngIf="bookingDetails?.coupanAmount>0">Coupon Discount</h4>
                        <h4 *ngIf="bookingDetails?.coupanAmount>0">- ${{bookingDetails.coupanAmount | removeDecimal}}
                        </h4>
                    </div>
                    <div *ngIf="bookingDetails?.taxAndFees>0" class="duration-inner">
                        <h4 *ngIf="bookingDetails?.taxAndFees>0">Taxes</h4>
                        <h4 *ngIf="bookingDetails?.taxAndFees >0"> ${{bookingDetails?.taxAndFees | digitFormat}}
                        </h4>
                    </div>
                    <div *ngIf="bookingDetails?.usedCredit>0" class="duration-inner">
                        <h4 *ngIf="bookingDetails?.usedCredit>0">Credits</h4>
                        <h4 *ngIf="bookingDetails?.usedCredit >0">- ${{bookingDetails?.usedCredit | digitFormat}}
                        </h4>
                    </div>

                    <div *ngIf="bookingDetails?.transactionFees>0" class="duration-inner">
                        <h4 *ngIf="bookingDetails?.transactionFees>0">Fee</h4>
                        <h4 *ngIf="bookingDetails?.transactionFees >0"> ${{bookingDetails?.transactionFees |
                            digitFormat}}
                        </h4>
                    </div>
                     <div *ngIf="bookingDetails?.exemptTaxesAndFees != null && bookingDetails?.exemptTaxesAndFees > 0" class="duration-inner">
                        <h4>Exempt Taxes And Fees</h4>
                        <h4> -${{bookingDetails?.exemptTaxesAndFees}}
                        </h4>
                    </div>
                </div>

                <div class="parking-durationbox" *ngIf="updateBookindDetailsValue && bookingType">
                    <div *ngIf="updateBookindDetailsValue?.duration" class="duration-inner">
                        <h4>Parking Duration</h4>
                        <h4>{{updateBookindDetailsValue?.duration}}</h4>
                    </div>
                    <div *ngIf="updateBookindDetailsValue?.amount" class="duration-inner">
                        <h4>Amount</h4>
                        <h4>${{updateBookindDetailsValue?.amount}}</h4>
                    </div>
                    <div *ngIf="updateBookindDetailsValue?.coupanAmount>0" class="duration-inner">
                        <h4 *ngIf="updateBookindDetailsValue?.coupanAmount>0">Coupon Discount</h4>
                        <h4 *ngIf="updateBookindDetailsValue?.coupanAmount>0">- ${{updateBookindDetailsValue.coupanAmount | removeDecimal}}
                        </h4>
                    </div>
                    <div *ngIf="updateBookindDetailsValue?.taxAndFees>0" class="duration-inner">
                        <h4 *ngIf="updateBookindDetailsValue?.taxAndFees>0">Taxes</h4>
                        <h4 *ngIf="updateBookindDetailsValue?.taxAndFees >0"> ${{updateBookindDetailsValue?.taxAndFees |
                            digitFormat}}
                        </h4>
                    </div>
                      <div *ngIf="updateBookindDetailsValue?.usedCredit" class="duration-inner">
                        <h4 *ngIf="updateBookindDetailsValue?.usedCredit">Credits</h4>
                        <h4 *ngIf="updateBookindDetailsValue?.usedCredit >0">- ${{updateBookindDetailsValue?.usedCredit |
                            digitFormat}}
                        </h4>
                    </div>
                    <div *ngIf="updateBookindDetailsValue?.transactionFees>0" class="duration-inner">
                        <h4 *ngIf="updateBookindDetailsValue?.transactionFees>0">Fee</h4>
                        <h4 *ngIf="updateBookindDetailsValue?.transactionFees >0">
                            ${{updateBookindDetailsValue?.transactionFees | digitFormat}}
                        </h4>
                    </div> 
                      <div *ngIf="updateBookindDetailsValue?.exemptTaxesAndFees != null && updateBookindDetailsValue?.exemptTaxesAndFees > 0" class="duration-inner">
                        <h4>Exempt Taxes And Fees</h4>
                        <h4> -${{updateBookindDetailsValue?.exemptTaxesAndFees}}
                        </h4>
                    </div>                   
                </div>

                <div class="parking-durationbox" *ngIf="!bookingType">
                    <div *ngIf="customInvoiceDetails?.getParkingLotInvoiceItems[0]?.baseAmount" class="duration-inner">
                        <h4>Amount</h4>
                        <h4>${{customInvoiceDetails?.getParkingLotInvoiceItems[0]?.baseAmount}}</h4>
                    </div>
                    <div *ngIf="customInvoiceDetails?.getParkingLotInvoiceItems[0]?.taxAmount>0" class="duration-inner">
                        <h4 *ngIf="customInvoiceDetails?.getParkingLotInvoiceItems[0]?.taxAmount>0">Taxes</h4>
                        <h4 *ngIf="customInvoiceDetails?.getParkingLotInvoiceItems[0]?.taxAmount >0"> ${{customInvoiceDetails?.getParkingLotInvoiceItems[0]?.taxAmount |
                            digitFormat}}
                        </h4>
                    </div>
                    <div *ngIf="customInvoiceDetails?.getParkingLotInvoiceItems[0]?.feesAmount>0" class="duration-inner">
                        <h4 *ngIf="customInvoiceDetails?.getParkingLotInvoiceItems[0]?.feesAmount>0">Fee</h4>
                        <h4 *ngIf="customInvoiceDetails?.getParkingLotInvoiceItems[0]?.feesAmount >0">
                            ${{customInvoiceDetails?.getParkingLotInvoiceItems[0]?.feesAmount | digitFormat}}
                        </h4>
                    </div>
                     <div *ngIf="customInvoiceDetails?.getParkingLotInvoiceItems[0]?.exemptTaxesAndFees >0" class="duration-inner">
                        <h4>Exempt Taxes And Fees</h4>
                        <h4> -${{customInvoiceDetails?.getParkingLotInvoiceItems[0]?.exemptTaxesAndFees | removeDecimal}}
                        </h4>
                    </div>
                </div>
                    <app-schedule-date-time-option *ngIf="isScheduleOptionShow && isPreferredPaymentSelected && !(roleName === userRoles.DRIVER || roleName === userRoles.GROUP_USER)" [bookingEndDate]="bookingEndDate"
                        [bookingType]="bookingDetails?.bookingType" [isSubmitButtonClicked]="isSubmitButtonClicked" [isScheduleCancelBookingMessage]="isScheduleCancelBookingMessage" [timeZone]="timeZone"  [bookingScheduledDate]="bookingScheduledDate"
                        (schdeuleDateTimeData)="schdeuleDateTimeData($event)">
                    </app-schedule-date-time-option>

                <div class="pay-new custom-paynew">
                    <div class="updated-outerbox">
                        <div class="inner-box">
                            <div class="pay-now">
                                <p-button [label]="'Pay Now'" (onClick)="isPreferredPaymentSelectedPayment()">
                                </p-button>

                            </div>
                        </div>

                    </div>
                    <div class="total-outer" *ngIf="bookingType">
                        <h4 *ngIf="!updateBookindDetailsValue">Total: ${{bookingDetails?.total | removeDecimal}}</h4>
                        <h4 *ngIf="updateBookindDetailsValue">Total: ${{updateBookindDetailsValue?.total |
                            removeDecimal}}</h4>
                    </div>
                    <div class="total-outer"  *ngIf="!bookingType">
                        <h4 *ngIf="customInvoiceDetails">Total: ${{customInvoiceDetails.getParkingLotInvoiceItems[0].totalAmount |
                            removeDecimal}}</h4>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>